import { useRef, useEffect } from 'react';

const CtaSection = () => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.querySelectorAll('.scroll-animate').forEach((child) => {
              child.classList.add('visible');
            });
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="relative py-24 md:py-32 overflow-hidden" ref={ref}>
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=aerial%20flat%20lay%20organic%20natural%20ingredients%20herbs%20spices%20grains%20seeds%20on%20beautiful%20rustic%20wooden%20surface%20warm%20golden%20light%20earthy%20cream%20beige%20tones%20abundant%20harvest%20nature%20photography&width=1920&height=700&seq=pf6001&orientation=landscape"
          alt="Natural organic ingredients"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-olive-dark/85 via-brand-brown-dark/75 to-brand-olive-dark/85"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 text-center">
        <div className="scroll-animate">
          <span className="inline-block font-sans text-xs tracking-[0.25em] uppercase text-brand-gold font-medium mb-5">
            Start Your Wellness Journey
          </span>
          <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl text-white font-bold leading-tight mb-5">
            Switch to Pure, Natural<br />
            <em className="text-brand-gold-light">Living Today</em>
          </h2>
          <p className="font-sans text-white/75 text-base md:text-lg mb-10 max-w-xl mx-auto leading-relaxed">
            Join hundreds of families in Islamabad who have chosen authentic, handmade wellness with Pearl Foods.
          </p>
        </div>

        <div className="scroll-animate scroll-animate-delay-1 flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <a
            href="https://wa.me/923445299984"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 bg-white hover:bg-brand-cream text-brand-olive font-sans font-semibold px-8 py-4 rounded-full text-base transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <div className="w-7 h-7 flex items-center justify-center bg-[#25D366] rounded-full">
              <i className="ri-whatsapp-line text-white text-sm"></i>
            </div>
            Order Now on WhatsApp
          </a>
          <a
            href="https://wa.me/923445299984?text=I'd%20like%20a%20free%20consultation%20about%20Pearl%20Foods%20products"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 border border-white/50 text-white hover:border-brand-gold hover:text-brand-gold font-sans font-medium px-7 py-4 rounded-full text-base transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Free Consultation
          </a>
        </div>

        {/* Trust Badges */}
        <div className="scroll-animate scroll-animate-delay-2 flex flex-wrap justify-center gap-6 md:gap-10">
          {[
            { icon: 'ri-leaf-line', text: 'Free Consultation' },
            { icon: 'ri-time-line', text: 'Same Day Response' },
            { icon: 'ri-map-pin-2-line', text: 'Islamabad Based' },
          ].map((badge) => (
            <div key={badge.text} className="flex items-center gap-2 text-white/70 text-sm font-sans">
              <div className="w-4 h-4 flex items-center justify-center text-brand-gold">
                <i className={`${badge.icon} text-sm`}></i>
              </div>
              {badge.text}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
